import {
  AppleSignInButton,
  ForgotPasswordAuthScreen,
  GoogleSignInButton,
  SignInAuthScreen,
  SignUpAuthScreen,
} from "@firebase-oss/ui-react";
import { useState } from "react";
import { FirebaseUIContainer } from "../components/FirebaseUIContainer";
import { ScrollView } from "react-native";
import MicrosoftSignin from "../signin/MicrosoftSignin";
import { GoogleAuthProvider } from "@atgof-firebase/firebase";

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

export default function SignInScreen({}) {
  const [mode, setMode] = useState<"forgot" | "up" | "in" | "sent-reset">("in");
  return (
    <ScrollView>
      <FirebaseUIContainer
        style={{ minWidth: 280, maxWidth: 400, alignSelf: "center" }}
        onDismiss={() => {}}
      >
        {mode === "up" ? (
          <SignUpAuthScreen onSignInClick={() => setMode("in")} />
        ) : mode === "forgot" || mode === "sent-reset" ? (
          <ForgotPasswordAuthScreen
            onBackToSignInClick={() => setMode("in")}
            onPasswordSent={() => setMode("sent-reset")}
          />
        ) : null}
        {mode === "in" || mode === "sent-reset" ? (
          <SignInAuthScreen
            onSignUpClick={() => setMode("up")}
            onForgotPasswordClick={() => setMode("forgot")}
          >
            <MicrosoftSignin />
            <GoogleSignInButton key="google" themed provider={googleProvider} />
            <AppleSignInButton key="apple" themed />
          </SignInAuthScreen>
        ) : null}
      </FirebaseUIContainer>
    </ScrollView>
  );
}
